
export const PORT = 443; // 32603;
export const SERVER = `https://www.codedread.dev:${PORT}`;
